// extracted by mini-css-extract-plugin
export default {"container":"AllDocuments_container__TPNLq","main":"AllDocuments_main__Bjp8n","body":"AllDocuments_body__NwoHB"};